import React, { useState, useEffect } from 'react'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import { connect, useSelector } from 'react-redux'
import { useHistory } from "react-router-dom";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Typography, Paper, Grid, Button, TextField, Checkbox, MenuItem, InputAdornment, DialogTitle, Dialog, DialogContent, DialogActions, Toolbar, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, DialogContentText, Chip, CircularProgress, LinearProgress } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import HttpService from '../../services/httpService';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { DownloadOutlined } from '@ant-design/icons';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import PersonIcon from '@material-ui/icons/Person';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import RoomIcon from '@material-ui/icons/Room';
import PhoneIcon from '@material-ui/icons/Phone';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import GroupIcon from '@material-ui/icons/Group';
import { useRef } from 'react';
import { CSVLink } from "react-csv";
import { ROLENAME } from '../../utils';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textFieldWidth: {
        width: "100%"
    },
    pageWrapper: {
        padding: 24,
        background: "#f4f6fb",
        minHeight: "100%",
    },
    formCard: {
        borderRadius: 18,
        boxShadow: "0 4px 24px rgba(28,55,93,0.1)",
        overflow: "hidden",
        maxWidth: 1200,
        margin: "0 auto",
    },
    dialogPaper: {
        borderRadius: 16,
        overflow: "hidden",
    },
    // Dialog is rendered in a portal, so it centers on the FULL viewport -
    // including the fixed left sidebar - which visually offsets it from the
    // form behind it. Nudging the flex container's left padding shifts the
    // centered dialog to the right so it lines up with the form's content
    // area instead. clamp() keeps the nudge proportional so it never pushes
    // the dialog off-screen on narrower windows.
    dialogContainerShift: {
        paddingLeft: "clamp(0px, 8vw, 140px)",
    },
    dialogTitle: {
        background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 60%, #2a78d6 100%)",
        color: "#fff",
        fontWeight: 700,
    },
    dialogActions: {
        padding: "14px 24px",
        borderTop: "1px solid #eceff3",
        background: "#fafbfc",
    },
    uploadZone: {
        textAlign: "center",
        border: "2px dashed #d7e0ee",
        borderRadius: 16,
        padding: "36px 24px",
        background: "#fafbfe",
        marginTop: 8,
        marginBottom: 8,
    },
    uploadZoneIconWrap: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: "#eef4fc",
        color: "#2a5ea8",
        marginBottom: 12,
    },
    uploadZoneActions: {
        display: "flex",
        gap: 12,
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 20,
    },
    '@keyframes pulseRing': {
        '0%': { boxShadow: "0 0 0 0 rgba(42,94,168,0.35)" },
        '70%': { boxShadow: "0 0 0 10px rgba(42,94,168,0)" },
        '100%': { boxShadow: "0 0 0 0 rgba(42,94,168,0)" },
    },
    '@keyframes popIn': {
        '0%': { transform: "scale(0)", opacity: 0 },
        '60%': { transform: "scale(1.2)", opacity: 1 },
        '100%': { transform: "scale(1)", opacity: 1 },
    },
    verifyingCard: {
        display: "flex",
        alignItems: "center",
        gap: 14,
        marginTop: 16,
        padding: "14px 18px",
        borderRadius: 14,
        background: "linear-gradient(135deg, #eef4fc 0%, #e4edfa 100%)",
        border: "1px solid #d6e4f7",
    },
    verifyingIconWrap: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 40,
        height: 40,
        borderRadius: "50%",
        background: "#fff",
        flexShrink: 0,
        animation: "$pulseRing 1.6s infinite",
    },
    verifyingProgressBar: {
        height: 6,
        borderRadius: 3,
        marginTop: 8,
    },
    popInIcon: {
        animation: "$popIn 400ms ease",
    },
    resultsHeaderRow: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 12,
        marginTop: 24,
        marginBottom: 14,
    },
    resultsHeaderTitle: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontWeight: 700,
        color: "#1C375D",
    },
    resultsSummaryChip: {
        fontWeight: 700,
        borderRadius: 16,
    },
    resultsTableWrap: {
        borderRadius: 14,
        overflow: "hidden",
        border: "1px solid #e2e8f2",
        boxShadow: "0 2px 12px rgba(28,55,93,0.08)",
    },
    resultsHeadCell: {
        background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 100%)",
        color: "#fff",
        fontWeight: 700,
        fontSize: 13,
        whiteSpace: "nowrap",
    },
    resultsRow: {
        transition: "background-color 150ms ease",
        "&:nth-of-type(even)": {
            backgroundColor: "#f7f9fc",
        },
        "&:hover": {
            backgroundColor: "#eef4fc",
        },
    },
    resultsSlCell: {
        color: "#7c8695",
        fontWeight: 600,
        textAlign: "center",
    },
    resultsStatusChip: {
        fontWeight: 700,
        borderRadius: 14,
    },
    headerBanner: {
        background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 60%, #2a78d6 100%)",
        padding: "24px 32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 16,
    },
    headerTitle: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontWeight: 700,
        color: "#fff",
        marginBottom: 4,
    },
    headerSubtitle: {
        color: "rgba(255,255,255,0.8)",
    },
    headerActions: {
        display: "flex",
        flexWrap: "nowrap",
        gap: 10,
        alignItems: "center",
        overflowX: "auto",
        paddingBottom: 4,
    },
    formBody: {
        padding: "32px 40px",
    },
    sectionTitle: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontWeight: 700,
        fontSize: 15,
        color: "#1C375D",
        marginTop: 28,
        marginBottom: 16,
        paddingBottom: 8,
        borderBottom: "2px solid #eef1f8",
    },
    pillButton: {
        borderRadius: 22,
        fontWeight: 600,
        textTransform: "none",
        boxShadow: "0 4px 10px rgba(42,120,214,0.28)",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: "0 6px 14px rgba(42,120,214,0.35)",
        },
    },
    pillButtonPlain: {
        borderRadius: 22,
        fontWeight: 600,
        textTransform: "none",
    },
    submitButton: {
        borderRadius: 26,
        fontWeight: 700,
        fontSize: 15,
        padding: "10px 0",
        boxShadow: "0 6px 16px rgba(42,120,214,0.35)",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: "0 8px 20px rgba(42,120,214,0.45)",
        },
    },
}))

const CreateLead = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { userDetails } = useSelector(state => state.user)
    useEffect(() => {
        getLeadMaster();
        // getUsers();
        getLocationList();
        // eslint-disable-next-line
    }, [])

    const [managerOfSalesTeam, setManagerOfSalesTeam] = useState([]);
    const [leadMaster, setLeadMaster] = useState([]);
    const [existingCustomerName, setExistingCustomerName] = useState("");
    const [dupManagerOfSalesTeam, setDupManagerOfSalesTeam] = useState([]);
    const [cities, setCities] = useState([]);
    const [expcenters, setExpcenters] = useState([]);
    const [invalidEmail, setInvalidEmail] = useState(true);
    const [invalidEmails, setInvalidEmails] = useState([]); // Array to track validity of each email
    const [fileUploaded, setFileUploaded] = useState(false);
    const [audioUploaded, setAudioUploaded] = useState(false);
    const [imageUploaded, setImageUploaded] = useState(false);
    const [addCustomersFileUploaded, setAddCustomersFileUploaded] = useState(false);
    const [openAddCustomerDialog, setOpenAddCustomerDialog] = useState(false);
    const [isCustomersLoaded, setIsCustomersLoaded] = useState(false);
    const [notCustomersAdded, setNotCustomersAdded] = useState([])
    // Live progress while /upload-bulk-leads-ai-verification's background job
    // is still processing rows - null once there's nothing to poll for.
    const [bulkLeadUploadProgress, setBulkLeadUploadProgress] = useState(null);
    const [defaultLocation, setDefaultLocation] = useState(userDetails.selectedLocation);
    const [storeDepartmentName, setDepartmentName] = useState(userDetails.departmentId);
    const [storeCriteria, setStoreCriteria] = useState([])
    const [isJunk, setIsJunk] = useState(false);
    const [isHold, setHold] = useState(false);
    const [leadMoved, setLeadMoved] = useState(false);
    const [openModal, setOpenModal] = useState(false);


    const [isAudioEnabled, setIsAudioEnabled] = useState(false);
    const [isImageEnabled, setIsImageEnabled] = useState(false);



    const buttonRef = useRef(null)
    const buttonRefAutomation = useRef();
    const failDownloadRef = useRef();
    const successDownloadRef = useRef();
    const bulkLeadsFileInputRef = useRef(null);
    const automationFileInputRef = useRef(null);

    // Inline "Downloading..." state for the CSV/Excel download buttons below -
    // they all fire a hidden CSVLink after a short delay, so without this the
    // button just sits there looking unresponsive for that window.
    const [excelSampleDownloading, setExcelSampleDownloading] = useState(false);
    const [automationExcelSampleDownloading, setAutomationExcelSampleDownloading] = useState(false);
    const [failedStatusDownloading, setFailedStatusDownloading] = useState(false);

    const [OpenAddCustomerDialogForAutomationLeads, setOpenAddCustomerDialogForAutomationLeads] = useState(false);
    const [isCustomersLoadedForAutomation, setIsCustomersLoadedForAutomation] = useState(false);
    const [addCustomersFileUploadedForAutomation, setAddCustomersFileUploadedForAutomation] = useState(false);
    const [failedAutomationLeads, setFailedAutomationLeads] = useState([]);
    const [successfulAutomationLeads, setSuccessfulAutomationLeads] = useState([]);
    const [successfulAutomationLeadsForCSV, setSuccessfulAutomationLeadsForCSV] = useState([]);
    const [failedAutomationLeadsForCSV, setFailedAutomationLeadsForCSV] = useState([]);
    const [loading, setLoading] = useState(false)
    // Live progress while /upload-bulk-leads-ai's background job is still
    // processing rows - same pattern as bulkLeadUploadProgress above.
    const [automationUploadProgress, setAutomationUploadProgress] = useState(null);


    const getLeadMaster = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getLeadMaster()
            const sourcesData = response.data.filter(item => item.name !== "Reference") // As the users are getting confused while selecting the Reference leads we are filtering Reference Source.
            setLeadMaster(sourcesData)
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const getLocationList = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getLocationList()
            // let filterLocation = response.data.filter((ele, i) => ele._id === userDetails.selectedLocation)
            setCities(response.data)
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const getExperienceCenterByLocation = async (e) => {
        setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value });
        props.setLoading(true)
        try {
            const response = await HttpService.getExpericenCentersByLocation(e.target.value)
            // const centerOption = response.data.filter(ele => ele._id === userDetails.selectedExpCenter);
            setExpcenters(response.data)
            getUsers();
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const getManagerBasedOnLocation = (e, city) => {
        setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })
        let salesManagerArr = []
        dupManagerOfSalesTeam.forEach(ele => {
            ele.experienceCenterId.forEach(ele1 => {
                if (ele1._id === e.target.value) {
                    salesManagerArr.push(ele)
                }
            })
        })
        setManagerOfSalesTeam(salesManagerArr)
    }


    const getUsers = async () => {
        props.setLoading(true)
        try {
            const result = await HttpService.getUsers()
            getSalesManager(result.data);
        } catch (error) {
            console.error(error)
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const getSalesManager = (data) => {
        let salesArr = [];
        let salesManagerArr = [];
        data.forEach(ele => {
            if (ele.roles?.find(role => role.name === 'Assistant Sales Manager' || role.name === 'Sales Manager') && ele?.teamId?.isActive === true && ele.isActive === true) {
                salesArr.push(ele);
                salesManagerArr.push(ele.teamId)
            }
        })
        // setManagerOfSalesTeam(salesManagerArr)
        setDupManagerOfSalesTeam(salesArr);
    }
    function testRegexEmpCxName(str) {
        return !/^[A-Za-z\s]+$/.test(str)
    }
    function testRegexEmpCxEmail(str) {
        return !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(str);
    }
    function testRegexEmpCxMobile(str) {
        return !/^[6-9]\d{9}$/.test(str)
    }

    const [leadFormData, setLeadFormData] = useState({
        customerName: "",
        address: "",
        projectType: "",
        area: "",
        propertyType: "",
        city: "",
        experienceCenterId: "",
        contact_no: "",
        reasonForOtherLeadType: "",
        alternativeContactNo: "",
        email: "",
        emails: [""],
        scopeOfWork: "",
        expectedTimeToCompletion: "",
        remark: "",
        startInteriors: "",
        isRegistered: "",
        sourceOfLead: "",
        estimatedBudget: "",
        floorPlan: "",
        leadType: "To Be Called",
        assignTo: "",
        assignToManager: "",
        expectedHandoverDate: ""
    })
    const { customerName, address, projectType, area, propertyType, city, experienceCenterId, contact_no, reasonForOtherLeadType, alternativeContactNo, email, scopeOfWork, expectedTimeToCompletion,
        remark, startInteriors, isRegistered, sourceOfLead, estimatedBudget, floorPlan, leadType, assignTo, assignToManager, expectedHandoverDate } = leadFormData

    const [mobileError, setMobileError] = useState("");
    const [btnDisable, setBtnDisable] = useState(false);
    const checkMobileExist = async (e) => {
        // regex to except only number in input field
        let mobileNo = e.target.value.replace(/[^0-9]/g, "");
        // eslint-disable-next-line no-new-wrappers
        let n = new String(e.target.value);
        setLeadFormData({ ...leadFormData, [e.target.name]: mobileNo })
        if (n.length === 10) {
            props.setLoading(true)
            try {
                const response = await HttpService.checkCustomer(mobileNo)
                setExistingCustomerName(response.data)
                setLeadFormData({ ...leadFormData, [e.target.name]: mobileNo })
            } catch (error) {
                setExistingCustomerName('');
            }
            props.setLoading(false)
            setMobileError('')
            setBtnDisable(false);
        } else if (n.length >= 10) {
            setMobileError('Invalid Mobile Number')
            setBtnDisable(true);
        } else {
            setBtnDisable(true)
        }
    }
    const [alternateMobileError, setAlternateMobileError] = useState("");
    const checkAlternateNumber = (e) => {
        setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })
        let alternateMobile = new String(e.target.value);
        if (alternateMobile.length === 10) {
            setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })
            setAlternateMobileError('')
        } else if (alternateMobile.length >= 10) {
            setAlternateMobileError('Invalid Mobile Number')
        }
    }

    const checkAssignDetail = (e) => {
        if (e.target.value) {
            let teamDetail = [];
            dupManagerOfSalesTeam.forEach(ele => {
                if (ele?._id === e.target.value) {
                    teamDetail.push(ele)
                }
            })
            setLeadFormData({
                ...leadFormData, [e.target.name]: e.target.value,
                'assignToName': teamDetail[0].name,
                'assignTo': teamDetail[0]._id,
                'department': teamDetail[0].departmentId._id,
                'team': teamDetail[0].teamId._id,
                'status': "Lead Received",
                'teamName': teamDetail[0].teamId.name,
            })
        } else {
            setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value, 'assignToName': '', 'assignTo': '', 'department': '', 'team': '', "teamName": '' })
        }
    }

    const addLead = async () => {
        // Check for required fields
        if (scopeOfWork === '' || expectedTimeToCompletion === '' || estimatedBudget === '') {
            return props.setSnackInfo("Please Fill All the Validate Field", 'warning');
        }
        if (leadMoved) {
            if (reasonForOtherLeadType === '') {
                return props.setSnackInfo("Please Enter the Reason to Assign Lead Other Than Real to Sales Person", 'warning');
            }
        }

        // Find the selected experience center
        const selectedExpCenter = expcenters.find(expcenter => expcenter._id === leadFormData?.experienceCenterId);
        const selectedCenterName = selectedExpCenter ? selectedExpCenter.name : '';

        // Find the selected city
        const findCity = cities.find(city => city._id === leadFormData?.city);
        const selectedCity = findCity ? findCity.name : '';

        // Initialize the object with city and experience center names
        let obj = {
            ...leadFormData,
            cityName: selectedCity,
            experienceCenterName: selectedCenterName,
            experienceCenterId: selectedExpCenter._id
        };


        if (leadType === "To Be Called") {
            obj = {
                ...obj,  // Spread the initial object first to preserve city and experience center names
                // ...leadFormData,  // Spread leadFormData to add/overwrite its properties
                assignTo: userDetails._id,
                department: userDetails.departmentId,
                team: userDetails.teamId._id,
                status: leadFormData.leadType,
                teamName: userDetails.teamId.name,
                assignToName: userDetails.name,
            };
        }
        // Conditional logic based on leadMoved and leadType
        else if (!leadMoved && leadType !== 'Real') {
            if (["Hold", "Junk"].includes(leadFormData.leadType)) {
                // console.log("first")
                obj = {
                    ...obj,  // Spread the initial object first to preserve city and experience center names
                    // ...leadFormData,  // Spread leadFormData to add/overwrite its properties
                    assignTo: userDetails._id,
                    department: userDetails.departmentId,
                    team: userDetails.teamId._id,
                    status: leadFormData.leadType,
                    teamName: userDetails.teamId.name,
                    assignToName: userDetails.name,
                };
            }
            else {
                obj = {
                    ...obj,  // Spread the initial object first to preserve city and experience center names
                    // ...leadFormData,  // Spread leadFormData to add/overwrite its properties
                    assignTo: userDetails._id,
                    department: userDetails.departmentId,
                    team: userDetails.teamId._id,
                    status: leadFormData.leadType,
                    teamName: userDetails.teamId.name,
                    assignToName: userDetails.name,
                };
            }
        } else {
            if (leadFormData.leadType === 'Real') {
                obj = {
                    ...obj,  // Spread the initial object first to preserve city and experience center names
                    // ...leadFormData,  // Spread leadFormData to add/overwrite its properties
                    teamName: leadFormData.teamName,
                    assignToName: leadFormData.assignToName,
                };
            } else {
                obj = {
                    ...obj,  // Spread the initial object first to preserve city and experience center names
                    // ...leadFormData,  // Spread leadFormData to add/overwrite its properties
                    teamName: leadFormData.teamName,
                    assignToName: leadFormData.assignToName,
                    leadType: 'Real'
                };
            }
        }
        const selectedSourceName = leadMaster?.find(item => item._id === sourceOfLead)?.name;
        const isDirectAssignSource = ['Reference Client', 'Reference Employee', 'Walk-In'].includes(selectedSourceName);

        props.setLoading(true)
        try {
            if (isDirectAssignSource) {
                const response = await HttpService.createCustomer(obj)
                history.push('/qtProjects');
                props.setSnackInfo(response?.data ?? "Customer Created successfully", "success")
            } else {
                const response = await HttpService.createLeadVerification(obj)
                history.push('/qtProjects');
                props.setSnackInfo(response?.data?.message ?? "Customer Created successfully", "success")
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? error?.response?.data?.error ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }
    const validateEmail = (e) => {
        let regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
        setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })
        if (regex.test(e.target.value)) {
            setInvalidEmail(false)
        } else {
            setInvalidEmail(true)
        }
    }

    // function to handle full name input 
    const fullNameChangeHandler = (event) => {
        const value = event.target.value;

        // Regex pattern to check for the presence of special characters
        // const specialCharacters = /^[^$&+,:;=?@#|'<>.^*()%!-€]*$/;

        // Regex pattern to check for the presence of only letters (uppercase & lowercase) and spaces and excluding special characters and numeric value
        const specialCharacters = /^[a-zA-Z\s]*$/;

        const containsSpecialCharacters = !specialCharacters.test(value);

        // If special characters is present display alert
        if (containsSpecialCharacters) {
            props.setSnackInfo("Input may only contain letters (uppercase or lowercase) and spaces, excluding special characters.", "warning");
        } else {
            setLeadFormData({ ...leadFormData, [event.target.name]: event.target.value });
        }
    }
    // function to handle sqFt area 
    const sqFtAreaChangeHandler = (event) => {
        // regex to except only number in input field
        let area = event.target.value.replace(/[^0-9]/g, "");
        setLeadFormData({ ...leadFormData, [event.target.name]: area })
    }

    const onImageChange = async (e) => {
        const { name, value } = e.target
        props.setLoading(true)
        const fd = new FormData()
        fd.append('file', e.target.files[0])
        fd.append('customerName', "floor" + '_' + "plan")
        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            setLeadFormData({
                ...leadFormData,
                [name]: fileUploadRes.data
            })
            if ([name][0] === "floorPlanAttachment") {
                setFileUploaded(true);
            } else if ([name][0] === "recordingFile") {
                setAudioUploaded(true)
            }
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }
    // for expected handover date: all dates after today can be choose
    const today = new Date().toISOString().split('T')[0];

    //  Add customers into erp while uploading the files
    const handleFileChange = async (e) => {
        //   props.setLoading(true)
        const fd = new FormData()
        fd.append('file', e.target.files[0])
        let randomData = Math.floor(Math.random() * 100)
        fd.append('customerName', "BulkData" + '_' + randomData)
        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            await callAddCustomers(fileUploadRes.data);
            setAddCustomersFileUploaded(true);
        } catch (err) {
            props.setSnackInfo("Something went wrong", "error")
        }
        //   props.setLoading(false)
    }

    const mapToAutomationCSV = (list) =>
        list.map(item => ({
            Full_Name: item.fullName || "",
            Phone_Number: item.phoneNumber || "",
            Email: item.email || "",
            Location: item.location || "",
            Experience_Center: item.experienceCenter || "",
            Scope_of_Work: item.scopeOfWork || "",
            Budget_Above_3_Lakhs: item.budget || "",
            Start_Project_Timeline: item.timeline || "",
            Platform: item.platform || ""
        }));

    // /upload-bulk-leads-ai only *starts* the job and replies with a jobId
    // (202) - poll its status endpoint until it leaves "processing", same
    // AiLeadUploadJob-backed pattern as pollBulkLeadVerificationJob below.
    const pollBulkLeadsAiJob = async (jobId) => {
        const POLL_INTERVAL_MS = 2500;
        const MAX_ATTEMPTS = 240; // ~10 minutes ceiling for very large files

        for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
            const { data: job } = await HttpService.getBulkLeadsAiJobStatus(jobId);

            if (job.status === 'processing') {
                setAutomationUploadProgress({
                    processedRows: job.summary?.processedRows || 0,
                    totalRows: job.summary?.totalRows || 0,
                });
                await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
                continue;
            }

            return job;
        }

        throw new Error('Bulk AI lead upload is taking longer than expected. Please check back shortly.');
    };

    const handleFileChangeAutomationLeads = async (e) => {
        props.setLoading(true)
        const fd = new FormData()
        fd.append('file', e.target?.files?.[0])
        let randomData = Math.floor(Math.random() * 100)
        fd.append('customerName', "BulkData" + '_' + randomData)
        try {
            setLoading(true)
            const fileUploadRes = await HttpService.uploadFile(fd);
            const s3Location = fileUploadRes?.data;
            if (s3Location) {
                const automationRes = await HttpService.uploadFileForAutomation({ s3Location });
                const failed = automationRes.data.failedLeads || [];
                const success = automationRes.data.successfulLeads || [];
                // For UI table
                setFailedAutomationLeads(failed);
                setSuccessfulAutomationLeads(success);
                // For CSV downloads
                setFailedAutomationLeadsForCSV(mapToAutomationCSV(failed));
                setAddCustomersFileUploadedForAutomation(true);
                setIsCustomersLoadedForAutomation(true);
                props.setSnackInfo(automationRes.data.message, "success");

            }
        } catch (err) {
            props.setSnackInfo("Something went wrong", "error")
        } finally {
            setLoading(false)
            props.setLoading(false)
        }
    }

    //  Add customers into erp while uploading the files for automation leads
    // const handleFileChangeAutomationLeads = async (e) => {
    //     const fd = new FormData()
    //     fd.append('file', e.target?.files?.[0])
    //     let randomData = Math.floor(Math.random() * 100)
    //     fd.append('customerName', "BulkData" + '_' + randomData)
    //     setLoading(true)
    //     try {
    //         const fileUploadRes = await HttpService.uploadFile(fd);
    //         const s3Location = fileUploadRes?.data;
    //         if (s3Location) {
    //             const res = await HttpService.uploadBulkLeadsAi({ s3Location });
    //             const jobId = res?.data?.jobId;
    //             if (!jobId) {
    //                 throw new Error('Bulk AI lead upload did not start correctly');
    //             }

    //             const job = await pollBulkLeadsAiJob(jobId);

    //             if (job.status === 'failed') {
    //                 setFailedAutomationLeads([]);
    //                 setSuccessfulAutomationLeads([]);
    //                 setFailedAutomationLeadsForCSV([]);
    //                 props.setSnackInfo(job.errorMessage || "Bulk AI lead upload failed", "error");
    //             } else {
    //                 // failedLeads + duplicateLeads share the same row shape
    //                 // (see the table below, which already reads `ele.reason`)
    //                 // so they can be shown/downloaded together.
    //                 const failed = [...(job.failedLeads || []), ...(job.duplicateLeads || [])];
    //                 const success = job.successfulLeads || [];
    //                 // For UI table
    //                 setFailedAutomationLeads(failed);
    //                 setSuccessfulAutomationLeads(success);
    //                 // For CSV downloads
    //                 setFailedAutomationLeadsForCSV(mapToAutomationCSV(failed));

    //                 const { successfulLeads = 0, failedLeads = 0, duplicateLeads = 0 } = job.summary || {};
    //                 props.setSnackInfo(
    //                     `Automation leads processed - ${successfulLeads} created, ${failedLeads} failed, ${duplicateLeads} duplicate.`,
    //                     failedLeads || duplicateLeads ? "warning" : "success"
    //                 );
    //             }

    //             setAddCustomersFileUploadedForAutomation(true);
    //             setIsCustomersLoadedForAutomation(true);
    //         }
    //     } catch (err) {
    //         props.setSnackInfo(err?.response?.data?.message || err.message || "Something went wrong", "error")
    //     }
    //     setAutomationUploadProgress(null);
    //     setLoading(false)
    // }


    // /upload-bulk-leads-ai-verification only *starts* the job and replies
    // with a jobId (202) - the actual successful/failed/duplicate rows only
    // exist once the background job finishes, so poll its status endpoint
    // until it leaves "processing".
    const pollBulkLeadVerificationJob = async (jobId) => {
        const POLL_INTERVAL_MS = 2500;
        const MAX_ATTEMPTS = 240; // ~10 minutes ceiling for very large files

        for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
            const { data: job } = await HttpService.getBulkLeadVerificationJobStatus(jobId);

            if (job.status === 'processing') {
                setBulkLeadUploadProgress({
                    processedRows: job.summary?.processedRows || 0,
                    totalRows: job.summary?.totalRows || 0,
                });
                await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
                continue;
            }

            return job;
        }

        throw new Error('Bulk lead verification is taking longer than expected. Please check back shortly.');
    };

    //  Send file and post to server customers list
    const callAddCustomers = async (filepath) => {
        try {
            let res = await HttpService.createBulkLeadVerification({ filepath });
            const jobId = res?.data?.jobId;
            if (!jobId) {
                throw new Error('Bulk upload did not start correctly');
            }

            const job = await pollBulkLeadVerificationJob(jobId);

            if (job.status === 'failed') {
                setNotCustomersAdded([]);
                props.setSnackInfo(job.errorMessage || "Bulk lead upload failed", "error");
            } else {
                // Unify the three separate arrays the job returns into the
                // single { name, contactNo, expCenter, assignTo, message }
                // shape the results table below already renders - an empty
                // message means the row succeeded.
                const successRows = (job.successfulLeads || []).map((lead) => ({
                    name: lead.fullName,
                    contactNo: lead.phoneNumber,
                    expCenter: lead.branch || '-',
                    assignTo: lead.assignTo,
                    message: "",
                }));
                const failedRows = [...(job.failedLeads || []), ...(job.duplicateLeads || [])].map((lead) => ({
                    name: lead.customerName,
                    contactNo: lead.contactNo,
                    expCenter: lead.branch || '-',
                    assignTo: '-',
                    message: lead.message,
                }));

                setNotCustomersAdded([...failedRows, ...successRows]);

                const { successfulLeads = 0, failedLeads = 0, duplicateLeads = 0 } = job.summary || {};
                props.setSnackInfo(
                    `Leads processed - ${successfulLeads} created, ${failedLeads} failed, ${duplicateLeads} duplicate.`,
                    failedLeads || duplicateLeads ? "warning" : "success"
                );
            }

            setIsCustomersLoaded(true)
        } catch (err) {
            setNotCustomersAdded([]);
            props.setSnackInfo(err?.response?.data?.message || err.message || "Something went wrong", "error")
        }
        setBulkLeadUploadProgress(null);
    }

    // Resets every piece of state the "Add Customers To ERP" (bulk leads)
    // dialog touches, so the next time it's opened it starts completely
    // fresh instead of showing the previous attempt's uploaded file/results.
    const closeAddCustomerDialog = () => {
        setOpenAddCustomerDialog(false);
        setAddCustomersFileUploaded(false);
        setIsCustomersLoaded(false);
        setNotCustomersAdded([]);
        setBulkLeadUploadProgress(null);
        if (bulkLeadsFileInputRef.current) {
            bulkLeadsFileInputRef.current.value = '';
        }
    };

    // Same reset-on-close as closeAddCustomerDialog above, for the "Add
    // Automation Leads / Customer to ERP" dialog.
    const closeAddCustomerDialogForAutomation = () => {
        setOpenAddCustomerDialogForAutomationLeads(false);
        setAddCustomersFileUploadedForAutomation(false);
        setIsCustomersLoadedForAutomation(false);
        setFailedAutomationLeads([]);
        setSuccessfulAutomationLeads([]);
        setFailedAutomationLeadsForCSV([]);
        setAutomationUploadProgress(null);
        setLoading(false);
        if (automationFileInputRef.current) {
            automationFileInputRef.current.value = '';
        }
    };

    // excel sample data download for adding multiple leads
    const headers = [
        { key: "customerName", label: "Customer Name" },
        { key: "apartmentName", label: "Apartment Name" },
        { key: "bhk", label: "BHK" },
        { key: "sqft", label: "SqFt" },
        { key: "branch", label: "Branch" },
        { key: "contactNo", label: "Contact No" },
        { key: "emailId", label: "Email Id" },
        { key: "scopeWork", label: "Scope of work" },
        { key: "estimatedBudget", label: "Estimated Budget" },
        { key: "expectedTimeToCompletion", label: "Expected Time To Completion" },
        { key: "whenStart", label: "When do we start" },
        { key: "registration", label: "Registration done" },
        { key: "source", label: "Source" },
        { key: "assignTo", label: "Assign to" },
    ];

    const excelData = [
        {
            customerName: "Test Customer",
            apartmentName: "Amrutha Heights phase 2",
            bhk: '2bhk',
            sqft: '1232',
            branch: 'HSR',
            contactNo: 9334657863,
            emailId: "aknandan.kumar@decorpot.in",
            scopeWork: "End to End implementation or entire home  (Real)",
            estimatedBudget: "Less than 3.5 Lakhs(Junk)",
            expectedTimeToCompletion: "Above 90 Days(Hold)",
            whenStart: "This month",
            registration: "Yes",
            source: "Facebook",
            assignTo: 'Daksha.Jain1@decorpot.com'
        },
        {
            customerName: "Aknandan Sharma",
            apartmentName: "New Town Kolkata",
            bhk: '2bhk',
            sqft: '1232',
            branch: 'HSR',
            contactNo: 9334657863,
            emailId: "aknandan.kumar@decorpot.in",
            scopeWork: "Kitchen and wardrobes + loose furniture and some elements.(Real)",
            estimatedBudget: "More than 3.5 Lakhs(Real)",
            expectedTimeToCompletion: "less than 30 days",
            whenStart: "This month",
            registration: "Yes",
            source: "Facebook",
            assignTo: 'Daksha.Jain1@decorpot.com'
        },
        {
            customerName: "Aknandan Sharma",
            apartmentName: "New Town Kolkata",
            bhk: '2bhk',
            sqft: '1232',
            branch: 'HSR',
            contactNo: 9334657863,
            emailId: "aknandan.kumar@decorpot.in",
            scopeWork: "Kitchens and wardrobes only (Real)",
            estimatedBudget: "More than 3.5 Lakhs(Real)",
            expectedTimeToCompletion: "30 to 90 Days",
            whenStart: "This month",
            registration: "Yes",
            source: "Facebook",
            assignTo: 'Daksha.Jain1@decorpot.com'
        }
    ]

    const downloadHeaders = [
        { key: "name", label: "Customer Name" },
        { key: "apartmentName", label: "Apartment Name" },
        { key: "bhk", label: "BHK" },
        { key: "sqft", label: "SqFt" },
        { key: "expCenter", label: "Branch" },
        { key: "contactNo", label: "Contact No" },
        { key: "emailId", label: "Email Id" },
        { key: "scopeOfWork", label: "Scope of work" },
        { key: "estimatedBudget", label: "Estimated Budget" },
        { key: "expectedTimeToCompletion", label: "Expected Time To Completion" },
        { key: "whenDoWeStart", label: "When do we start" },
        { key: "registrationDone", label: "Registration done" },
        { key: "source", label: "Source" },
        { key: "assignTo", label: "Assign to" },
        { key: "reasonForFail", label: "Reason for Fail" },
        { key: "statusOfLeadCreation", label: "Status of Lead creation" }
    ];
    // excel sample data download for adding multiple leads for automation leads
    const headersForAutomationLeads = [
        { key: "Full_Name", label: "Full Name" },
        { key: "Phone_Number", label: "Phone Number" },
        { key: "Email", label: "Email" },
        { key: "Location", label: "Location" },
        { key: "Experience_Center", label: "Experience Center" },
        { key: "Scope_of_Work", label: "Scope of Work" },
        { key: "Budget_Above_3_Lakhs", label: "Budget Above 3 Lakhs" },
        { key: "Start_Project_Timeline", label: "Start Project Timeline 90 Day(Yes/No)" },
        { key: "Platform", label: "Platform" }
    ];

    const AutomationLeadsExampleExcelData = [
        {
            Full_Name: "Parimal Radhe",
            Phone_Number: "6294463321",
            Email: 'parimal.pramanik@decorpot.com',
            Location: 'Bangalore',
            Experience_Center: 'Kolkata',
            Scope_of_Work: "End to End implementation or entire home (Real)",
            Budget_Above_3_Lakhs: "No",
            Start_Project_Timeline: "Yes",
            Platform: "Facebook",
        },
        {
            Full_Name: "Divakar P",
            Phone_Number: "9875674563",
            Email: 'divakar.ps@decorpot.com',
            Location: 'Kolkata',
            Experience_Center: 'abc',
            Scope_of_Work: "kitchens and wardrobes only (Real)",
            Budget_Above_3_Lakhs: "Yes",
            Start_Project_Timeline: "No",
            Platform: "Facebook",
        },
        {
            Full_Name: "Radhe",
            Phone_Number: "9878987651",
            Email: 'radhe@decorpot.com',
            Location: 'NCR',
            Experience_Center: 'Noida',
            Scope_of_Work: "Kitchen and wardrobes + loose furniture and some elements.(Real)",
            Budget_Above_3_Lakhs: "Yes",
            Start_Project_Timeline: "No",
            Platform: "Whatsapp",
        }
    ]

    const addCustomersToErp = (Array.isArray(notCustomersAdded) ? notCustomersAdded : []).map((customer, index) => ({
        name: customer.name,
        email: 'yes',
        contactNo: customer.contactNo,
        expCenter: customer.expCenter,
        message: "Assigned person email does not exist",
        emailId: customer.emailId,
        apartmentName: customer.apartmentName,
        bhk: customer.bhk,
        sqft: customer.sqft,
        scopeOfWork: customer.scopeOfWork,
        estimatedBudget: customer.estimatedBudget,
        expectedTimeToCompletion: customer.expectedTimeToCompletion,
        whenDoWeStart: customer.whenDoWeStart,
        registrationDone: customer.registrationDone,
        source: customer.source,
        assignTo: customer.assignTo,
        index: index,
        reasonForFail: customer.message,
        statusOfLeadCreation: (customer.message === "") ? "Success" : "Fail",
    }));

    // Derived summary counts for the upload-results table below - purely
    // for display (SL No / success-fail chips), no new data fetched.
    const bulkUploadResultRows = Array.isArray(notCustomersAdded) ? notCustomersAdded : [];
    const bulkUploadSuccessCount = bulkUploadResultRows.filter((row) => row.message === "").length;
    const bulkUploadFailCount = bulkUploadResultRows.length - bulkUploadSuccessCount;

    // Same unified-row shape for the automation-leads results table -
    // successful + failed/duplicate rows combined into one list so it can
    // render with the same SL No / status-chip table as bulk leads above.
    const automationResultRows = [
        ...(Array.isArray(successfulAutomationLeads) ? successfulAutomationLeads : []).map((lead) => ({
            name: lead.fullName,
            contactNo: lead.phoneNumber,
            email: lead.email,
            location: lead.location || '-',
            expCenter: lead.experienceCenter || '-',
            platform: lead.platform,
            message: "",
        })),
        ...(Array.isArray(failedAutomationLeads) ? failedAutomationLeads : []).map((lead) => ({
            name: lead.fullName,
            contactNo: lead.phoneNumber,
            email: lead.email,
            location: lead.location,
            expCenter: lead.experienceCenter,
            platform: lead.platform,
            message: lead.reason || "Failed",
        })),
    ];
    const AutomationLeadsExampleExcelDataDownload = () => {
        setAutomationExcelSampleDownloading(true);
        try {
            setTimeout(() => {
                buttonRefAutomation?.current?.link?.click();
                setAutomationExcelSampleDownloading(false);
            }, 1000);
        } catch (err) {
            console.error(err.message);
            setAutomationExcelSampleDownloading(false);
        }
        props.setLoading(false)
    }
    const downloadFailed = () => {
        setFailedStatusDownloading(true);
        try {
            setTimeout(() => {
                failDownloadRef?.current?.link?.click();
                setFailedStatusDownloading(false);
            }, 1000);
        } catch (err) {
            console.error(err.message);
            setFailedStatusDownloading(false);
        }
        props.setLoading(false)
    }
    const excelSampleDownload = () => {
        setExcelSampleDownloading(true);
        try {
            setTimeout(() => {
                buttonRef.current.link.click();
                setExcelSampleDownloading(false);
            }, 1000);
        } catch (err) {
            console.error(err.message);
            setExcelSampleDownloading(false);
        }
        props.setLoading(false)
    }
    const getLeadCriteria = async () => {
        let res = await HttpService.getLeadCriteria();
        const extractCityData = res.data
            .filter(el => el._id === leadFormData?.city);
        setStoreCriteria(extractCityData[0])
    }
    const handleCriteria = (e) => {
        const { name, value } = e.target;

        const newLeadFormData = { ...leadFormData, [name]: value };
        if (newLeadFormData.estimatedBudget.includes('Junk')) {
            setIsJunk(true)
        } else {
            setIsJunk(false);
        }
        setLeadFormData(newLeadFormData);



    }
    const handleClickOpen = () => {
        setOpenModal(true);
    };

    const handleClose = () => {
        addLead()
        setOpenModal(false);
    };

    const handleYes = () => {
        setLeadMoved(true);
        setOpenModal(false);
    };
    const addEmailField = () => {
        if (leadFormData.emails.length < 3) {
            setLeadFormData({ ...leadFormData, emails: [...leadFormData.emails, ""] });
        } else {
            props.setSnackInfo("You Can't Add More than 3 Emails", "warning")
        }
    };

    const removeEmailField = (index) => {
        const newEmails = leadFormData.emails.filter((_, i) => i !== index);
        setLeadFormData({ ...leadFormData, emails: newEmails });
    };


    const handleEmailChange = (index, event) => {
        const newEmails = [...leadFormData.emails];
        const emailValue = event.target.value;

        // Email validation regex
        const regex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

        // Update the email at the specified index
        newEmails[index] = emailValue;
        setLeadFormData({ ...leadFormData, emails: newEmails, email: newEmails[0] });

        // Clone the invalid emails state
        const newInvalidEmails = [...invalidEmails];

        // Validate the email and update the invalid emails array
        newInvalidEmails[index] = !regex.test(emailValue);

        // Update the invalidEmails state
        setInvalidEmails(newInvalidEmails);

        // Check if all emails are valid (none of the elements in newInvalidEmails is true)
        const allValid = newInvalidEmails.every(valid => !valid); // returns true if all emails are valid

        // Set invalidEmail to false only if all emails are valid
        setInvalidEmail(!allValid); // If allValid is true, invalidEmail becomes false
    };


    useEffect(() => {
        var checkEmails = leadFormData.emails.every((el) => el);

        if (checkEmails === true) {
            setBtnDisable(false);
        } else {
            setBtnDisable(true);
        }
    }, [leadFormData.emails]); // This effect will run whenever leadFormData.emails changes

    useEffect(() => {
        getLeadCriteria()
    }, [leadFormData.city])

    const isFileUploaded = () => {
        // Check if either image or recording file exists
        return !!leadFormData['uploadedImage'] || !!leadFormData['recordingFile'];
    };

    const selectedSource = leadMaster?.find(item => item._id === sourceOfLead)?.name;
    return (
        <div className={classes.pageWrapper}>
            <div className={classes.root}>
                <Paper className={classes.formCard}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div className={classes.headerBanner}>
                            <div>
                                <Typography variant="h5" className={classes.headerTitle}>
                                    <AssignmentIcon />
                                    Decorpot Lead Details
                                </Typography>
                                <Typography variant="body2" className={classes.headerSubtitle}>
                                    Customer details for Keeping a track!
                                </Typography>
                            </div>
                            {
                                userDetails.roles.find(role => role.name !== ROLENAME.TeleCallerManager && role.name !== ROLENAME.TeleCallerUser) && (
                                    <div className={classes.headerActions}>
                                        <Button className={classes.pillButtonPlain} style={{ background: '#fff', color: '#1C375D' }} variant="contained" startIcon={<CloudUploadIcon />} onClick={() => setOpenAddCustomerDialog(true)}>Upload Bulk Leads</Button>
                                        {
                                            <>
                                                <CSVLink
                                                    headers={headers}
                                                    filename={"bulk leads data" + '.csv'}
                                                    data={excelData}
                                                    ref={buttonRef}
                                                />
                                                <Button
                                                    className={classes.pillButtonPlain}
                                                    style={{ background: "#2e7d32", color: "white" }}
                                                    onClick={excelSampleDownload}
                                                    disabled={excelSampleDownloading}
                                                    startIcon={excelSampleDownloading ? <CircularProgress size={16} thickness={5} style={{ color: "#fff" }} /> : <DownloadOutlined />}
                                                >
                                                    {excelSampleDownloading ? "Downloading..." : "Excel Sample"}
                                                </Button>
                                            </>
                                        }


                                        <Button className={classes.pillButtonPlain} style={{ background: '#fff', color: '#1C375D' }} variant="contained" startIcon={<CloudUploadIcon />} onClick={() => setOpenAddCustomerDialogForAutomationLeads(true)}>Upload Bulk Automation Leads</Button>
                                        {
                                            <>
                                                <CSVLink
                                                    headers={headersForAutomationLeads}
                                                    filename={"Upload Bulk Automation Leads" + '.csv'}
                                                    data={AutomationLeadsExampleExcelData}
                                                    ref={buttonRefAutomation}
                                                />
                                                <Button
                                                    className={classes.pillButtonPlain}
                                                    style={{ background: "#2e7d32", color: "white" }}
                                                    onClick={AutomationLeadsExampleExcelDataDownload}
                                                    disabled={automationExcelSampleDownloading}
                                                    startIcon={automationExcelSampleDownloading ? <CircularProgress size={16} thickness={5} style={{ color: "#fff" }} /> : <DownloadOutlined />}
                                                >
                                                    {automationExcelSampleDownloading ? "Downloading..." : "Automation Leads Excel Sample"}
                                                </Button>
                                            </>
                                        }
                                    </div>
                                )}
                        </div>
                        <div className={classes.formBody}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Dialog
                                    open={openAddCustomerDialog}
                                    onClose={closeAddCustomerDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                    fullWidth
                                    maxWidth="lg"
                                    classes={{ container: classes.dialogContainerShift }}
                                    PaperProps={{ className: classes.dialogPaper }}
                                >
                                    <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>{"Add Customers To ERP"}</DialogTitle>
                                    <DialogContent style={{ paddingTop: 24, paddingBottom: 8 }}>
                                        <div className={classes.uploadZone}>
                                            <div className={classes.uploadZoneIconWrap}>
                                                <CloudUploadIcon fontSize="large" />
                                            </div>
                                            <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#1C375D' }}>
                                                Upload your leads Excel file
                                            </Typography>
                                            <Typography variant="body2" style={{ color: '#7c8695' }}>
                                                Accepts .xlsx / .xls - we'll verify each row and create the leads automatically
                                            </Typography>

                                            <div className={classes.uploadZoneActions}>
                                                <input
                                                    accept=".xlsx, .xls"
                                                    className={classes.input}
                                                    id="contained-button-customer"
                                                    multiple
                                                    type="file"
                                                    ref={bulkLeadsFileInputRef}
                                                    disabled={isCustomersLoaded || Boolean(bulkLeadUploadProgress)}
                                                    onChange={handleFileChange}
                                                    style={{ display: 'none' }}
                                                    name="filepath"
                                                />
                                                <label htmlFor="contained-button-customer">
                                                    <Button className={classes.pillButton} variant="contained" color="primary"
                                                        disabled={isCustomersLoaded || Boolean(bulkLeadUploadProgress)}
                                                        component="span"
                                                        startIcon={bulkLeadUploadProgress ? <CircularProgress size={16} thickness={5} style={{ color: "#fff" }} /> : <CloudUploadIcon />}>
                                                        {bulkLeadUploadProgress ? "Verifying..." : "Upload Leads File"}
                                                    </Button>
                                                </label>
                                                {addCustomersFileUploaded && <CheckCircleIcon className={classes.popInIcon} style={{ color: "green", fontSize: 30 }} />}

                                                {/* This is download excel file with status */}
                                                <label htmlFor="download-contained-button-customer">
                                                    <CSVLink
                                                        headers={downloadHeaders}
                                                        filename={"bulk leads data with status" + '.csv'}
                                                        data={addCustomersToErp}
                                                        ref={buttonRef}
                                                    />
                                                    <Button className={classes.pillButton} variant="contained" color="primary"
                                                        disabled={!isCustomersLoaded || excelSampleDownloading}
                                                        component="span"
                                                        startIcon={excelSampleDownloading ? <CircularProgress size={16} thickness={5} style={{ color: "#fff" }} /> : <CloudDownloadIcon />}
                                                        onClick={excelSampleDownload} >
                                                        {excelSampleDownloading ? "Downloading..." : "Download status of leads file"}
                                                    </Button>
                                                </label>
                                            </div>
                                        </div>

                                        {bulkLeadUploadProgress && (
                                            <div className={classes.verifyingCard}>
                                                <div className={classes.verifyingIconWrap}>
                                                    <CircularProgress size={22} thickness={5} style={{ color: "#2a5ea8" }} />
                                                </div>
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <Typography variant="body2" style={{ color: '#1C375D', fontWeight: 700 }}>
                                                        Verifying &amp; creating leads...
                                                    </Typography>
                                                    <Typography variant="caption" style={{ color: '#5a6c85' }}>
                                                        {bulkLeadUploadProgress.totalRows
                                                            ? `${bulkLeadUploadProgress.processedRows} of ${bulkLeadUploadProgress.totalRows} rows processed - please don't close this window`
                                                            : "Reading your file - please don't close this window"}
                                                    </Typography>
                                                    <LinearProgress
                                                        className={classes.verifyingProgressBar}
                                                        variant={bulkLeadUploadProgress.totalRows ? "determinate" : "indeterminate"}
                                                        value={
                                                            bulkLeadUploadProgress.totalRows
                                                                ? Math.min(100, Math.round((bulkLeadUploadProgress.processedRows / bulkLeadUploadProgress.totalRows) * 100))
                                                                : 0
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {addCustomersFileUploaded &&
                                            <>
                                                <div className={classes.resultsHeaderRow}>
                                                    <Typography variant="h6" className={classes.resultsHeaderTitle}>
                                                        <AssignmentIcon /> Upload Results
                                                    </Typography>
                                                    <Chip
                                                        size="small"
                                                        className={classes.resultsSummaryChip}
                                                        icon={<CheckCircleIcon style={{ color: "#1e7e34" }} />}
                                                        label={`${bulkUploadSuccessCount} Created`}
                                                        style={{ background: "#e6f4ea", color: "#1e7e34" }}
                                                    />
                                                    <Chip
                                                        size="small"
                                                        className={classes.resultsSummaryChip}
                                                        icon={<ErrorIcon style={{ color: "#c62828" }} />}
                                                        label={`${bulkUploadFailCount} Failed`}
                                                        style={{ background: "#fdecea", color: "#c62828" }}
                                                    />
                                                </div>

                                                <TableContainer component={Paper} className={classes.resultsTableWrap}>
                                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                                        <TableHead>
                                                            <StyledTableRow>
                                                                <TableCell className={classes.resultsHeadCell} align="center">SL No</TableCell>
                                                                <TableCell className={classes.resultsHeadCell}>Customer Name</TableCell>
                                                                <TableCell className={classes.resultsHeadCell}>Contact No.</TableCell>
                                                                <TableCell className={classes.resultsHeadCell}>Experience Center</TableCell>
                                                                <TableCell className={classes.resultsHeadCell}>Assign To</TableCell>
                                                                <TableCell className={classes.resultsHeadCell}>Error Message</TableCell>
                                                                <TableCell className={classes.resultsHeadCell} align="center">Lead Status</TableCell>
                                                            </StyledTableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {bulkUploadResultRows.map((ele, i) => {
                                                                const isSuccess = ele.message === "";
                                                                return (
                                                                    <TableRow key={i} className={classes.resultsRow}>
                                                                        <TableCell className={classes.resultsSlCell}>{i + 1}</TableCell>
                                                                        <TableCell>{ele.name}</TableCell>
                                                                        <TableCell>{ele.contactNo}</TableCell>
                                                                        <TableCell>{ele.expCenter}</TableCell>
                                                                        <TableCell>{ele.assignTo}</TableCell>
                                                                        <TableCell style={{ color: isSuccess ? "#9aa5b1" : "#c62828" }}>
                                                                            {isSuccess ? "—" : ele.message}
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            <Chip
                                                                                size="small"
                                                                                className={classes.resultsStatusChip}
                                                                                icon={isSuccess
                                                                                    ? <CheckCircleIcon style={{ fontSize: 16, color: "#1e7e34" }} />
                                                                                    : <ErrorIcon style={{ fontSize: 16, color: "#c62828" }} />}
                                                                                label={isSuccess ? "Success" : "Fail"}
                                                                                style={{
                                                                                    background: isSuccess ? "#e6f4ea" : "#fdecea",
                                                                                    color: isSuccess ? "#1e7e34" : "#c62828",
                                                                                }}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </>
                                        }
                                    </DialogContent>

                                    <DialogActions className={classes.dialogActions}>
                                        <Button onClick={closeAddCustomerDialog} variant="outlined" color="primary" className={classes.pillButtonPlain} autoFocus >
                                            Cancel
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                <Typography className={classes.sectionTitle} style={{ marginTop: 8 }}>
                                    <PersonIcon fontSize="small" /> Customer &amp; Property Details
                                </Typography>
                                <TextField fullWidth label="Full Name *" size="small" style={{ marginBottom: 20, textAlign: "center" }} name="customerName" value={customerName} onChange={(event) => fullNameChangeHandler(event)} variant="outlined" />

                                <TextField fullWidth label="Apartment / Independent House Name & Location *" size="small" style={{ marginBottom: 20, textAlign: "center" }} name="address" value={address} onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })} variant="outlined" />

                                <FormLabel component="legend">BHK Type</FormLabel>
                                <RadioGroup size="small" style={{ display: 'block', marginBottom: 20 }} aria-label="BHK" name="projectType" value={projectType} onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })}>
                                    <FormControlLabel value="1BHK" control={<Radio />} label="1BHK" />
                                    <FormControlLabel value="2BHK" control={<Radio />} label="2BHK" />
                                    <FormControlLabel value="3BHK" control={<Radio />} label="3BHK" />
                                    <FormControlLabel value="Villa" control={<Radio />} label="Villa" />
                                </RadioGroup>

                                <TextField fullWidth label="Sq.Ft Area *" size="small" style={{ marginBottom: 20, textAlign: "center" }} name="area" value={area} onChange={sqFtAreaChangeHandler} variant="outlined" />

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        id="outlined-select-currency"
                                        select
                                        label="Property Type"
                                        value={propertyType}
                                        name="propertyType"
                                        onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        <MenuItem value='Residential/New Apartment'>Residential/New Apartment</MenuItem>
                                        <MenuItem value='Independent House'>Independent House</MenuItem>
                                        <MenuItem value='Commercial'>Commercial</MenuItem>
                                        <MenuItem value='Renovation'>Renovation</MenuItem>
                                    </TextField>
                                </FormControl>

                                <Typography className={classes.sectionTitle}>
                                    <RoomIcon fontSize="small" /> Location Details
                                </Typography>
                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="city"
                                        value={city}
                                        label="City *"
                                        onChange={getExperienceCenterByLocation}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            cities?.map((data, i) => (
                                                <MenuItem value={data._id} key={i + 1}>{data.name}</MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-expcenter-simple-select"
                                        name="experienceCenterId"
                                        value={experienceCenterId}
                                        label="Experience Center *"
                                        onChange={(e) => getManagerBasedOnLocation(e, leadFormData.city)}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            expcenters?.map((data, i) => (
                                                <MenuItem value={data._id} key={i + 1}>{data.name}</MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </FormControl>

                                <Typography className={classes.sectionTitle}>
                                    <PhoneIcon fontSize="small" /> Contact Details
                                </Typography>
                                <TextField fullWidth label="Contact Number *" size="small" style={{ marginBottom: 20, textAlign: "center" }} name="contact_no" value={contact_no} onChange={checkMobileExist} variant="outlined" />
                                <span style={{ color: "red", marginBottom: 20, marginTop: -20 }}>{existingCustomerName}</span>
                                <span style={{ color: 'red', marginBottom: 20, marginTop: -20 }}>{mobileError}</span>
                                <TextField fullWidth label="Alternate Contact Number" size="small" style={{ marginBottom: 20, textAlign: "center" }} name="alternativeContactNo" value={alternativeContactNo} variant="outlined" onChange={checkAlternateNumber} />
                                <span style={{ color: "red", marginBottom: 20, marginTop: -20 }}>{alternateMobileError}</span>
                                <Grid container spacing={2}>
                                    {leadFormData?.emails?.map((email, index) => (
                                        <Grid container item xs={12} spacing={2} alignItems="center" key={index}>
                                            <Grid item xs={8}>
                                                <TextField
                                                    label={`Email ${index + 1} *`}
                                                    style={{ marginBottom: 20 }}
                                                    size="small"
                                                    type="email"
                                                    name={`email-${index}`}
                                                    value={email}
                                                    onChange={(e) => handleEmailChange(index, e)}
                                                    variant="outlined"
                                                    fullWidth
                                                    error={invalidEmails[index]}
                                                    helperText={invalidEmails[index] ? "Please enter a valid email" : ""}
                                                />
                                            </Grid>

                                            <Grid item xs={2} style={{ display: "flex", justifyContent: "center" }}>
                                                {index !== 0 && (
                                                    <IconButton
                                                        onClick={() => removeEmailField(index)}
                                                        color="secondary"
                                                        style={{ marginTop: 0 }} // Align with input field
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                )}
                                                <Button
                                                    className={classes.pillButton}
                                                    onClick={addEmailField}
                                                    color="primary"
                                                    variant="contained"
                                                    startIcon={<AddIcon />}
                                                    style={{ marginBottom: '1rem', marginLeft: "5px" }} // Align with input field
                                                >
                                                    Add
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                                <Typography className={classes.sectionTitle}>
                                    <HomeWorkIcon fontSize="small" /> Scope &amp; Budget
                                </Typography>
                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={scopeOfWork}
                                        name="scopeOfWork"
                                        label="Scope Of Work *"
                                        onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            storeCriteria?.scopeData?.map((data, i) => (
                                                <MenuItem value={data?.name} key={i + 1}>{data.name}</MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={estimatedBudget}
                                        name="estimatedBudget"
                                        label="Estimated Budget *"
                                        onChange={(e) => handleCriteria(e)}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            storeCriteria?.budgets?.map((data, i) => (
                                                <MenuItem value={data.budget} key={i + 1}>{data.budget}</MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={expectedTimeToCompletion}
                                        name="expectedTimeToCompletion"
                                        label="ExpectedTime ToCompletion *"
                                        onChange={(e) => handleCriteria(e)}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            !isJunk ?
                                                storeCriteria?.timelines?.map((data, i) => (
                                                    !data.timeline.includes('Hold') && (
                                                        <MenuItem value={data.timeline} key={i}>{data.timeline}</MenuItem>
                                                    )
                                                ))
                                                :
                                                storeCriteria?.timelines?.filter(data => data.timeline.includes('Hold')).map((data, i) => (
                                                    <MenuItem value={data.timeline} key={i}>{data.timeline}</MenuItem>
                                                ))
                                        }

                                    </TextField>
                                </FormControl>

                                <Typography className={classes.sectionTitle}>
                                    <AssignmentIcon fontSize="small" /> Additional Details
                                </Typography>

                                <TextField fullWidth label="Other Details or Remark" size="small" style={{ marginBottom: 20, textAlign: "center" }} name="remark" value={remark} onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })} variant="outlined" />

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={startInteriors}
                                        name="startInteriors"
                                        label="When do you want to start the interiors?"
                                        onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        <MenuItem value='This month'>This month</MenuItem>
                                        <MenuItem value='1-4 months'>1-4 months</MenuItem>
                                        <MenuItem value='>4months'> More Than 4 months</MenuItem>
                                    </TextField>
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={isRegistered}
                                        name="isRegistered"
                                        label="Registration Done/ Occupation Certificate Received?"
                                        onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        <MenuItem value='Yes'>Yes</MenuItem>
                                        <MenuItem value='No'>No</MenuItem>
                                        <MenuItem value='Will get it in 15-20 days'>Will get it in 15-20 days</MenuItem>
                                    </TextField>
                                </FormControl>
                                {/*referral ui ui from here */}
                                <Typography className={classes.sectionTitle}>
                                    <GroupIcon fontSize="small" /> Lead Source
                                </Typography>
                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={sourceOfLead}
                                        name="sourceOfLead"
                                        label="Source (Only on Incoming Calls) *"
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setLeadFormData({
                                                ...leadFormData,
                                                sourceOfLead: selectedValue,
                                                referredByCxName: selectedValue === "Reference Client" ? "" : "",
                                                referredByCxEmail: selectedValue === "Reference Client" ? "" : "",
                                                referredByCxUniqueLeadNumber: selectedValue === "Reference Client" ? "" : "",
                                                referredByEmpName: selectedValue === "Reference Employee" ? "" : "",
                                                referredByEmpEmail: selectedValue === "Reference Employee" ? "" : "",
                                                referredByCxMobile: selectedValue === "Reference Client" ? "" : "",
                                                referredByEmpMobile: selectedValue === "Reference Employee" ? "" : "",
                                            });;
                                        }}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            leadMaster?.map((data, i) => (
                                                <MenuItem value={data._id} key={i + 1}>{data.name}</MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </FormControl>
                                {(() => {


                                    if (selectedSource === "Reference Client") {
                                        return (
                                            <>
                                                <TextField
                                                    label="Enter Reference Client Name"
                                                    size="small"
                                                    fullWidth
                                                    style={{ marginBottom: 20 }}
                                                    name="referredByCxName"
                                                    value={leadFormData.referredByCxName || ""}
                                                    onChange={(e) => setLeadFormData({
                                                        ...leadFormData,
                                                        referredByCxName: e.target.value,
                                                        referredByEmpName: "",
                                                        referredByEmpMobile: ""
                                                    })}
                                                    variant="outlined"
                                                    error={leadFormData.referredByCxName.length > 0 && testRegexEmpCxName(leadFormData.referredByCxName)}
                                                    helperText={
                                                        leadFormData.referredByCxName.length > 0 &&
                                                            testRegexEmpCxName(leadFormData.referredByCxName)
                                                            ? "Name should not contain any sign or number"
                                                            : ""
                                                    }
                                                />
                                                <TextField
                                                    label="Enter Reference Client Email"
                                                    size="small"
                                                    fullWidth
                                                    style={{ marginBottom: 20 }}
                                                    name="referredByCxEmail"
                                                    value={leadFormData.referredByCxEmail || ""}
                                                    onChange={(e) => setLeadFormData({
                                                        ...leadFormData,
                                                        referredByCxEmail: e.target.value,
                                                        referredByEmpName: "",
                                                        referredByEmpMobile: ""
                                                    })}
                                                    variant="outlined"
                                                    error={
                                                        leadFormData.referredByCxEmail.length > 0 &&
                                                        testRegexEmpCxEmail(leadFormData.referredByCxEmail)
                                                    }
                                                    helperText={
                                                        leadFormData.referredByCxEmail.length > 0 &&
                                                            testRegexEmpCxEmail(leadFormData.referredByCxEmail)
                                                            ? "Please enter a valid email address"
                                                            : ""
                                                    }
                                                />
                                                <TextField
                                                    label="Enter Reference Client Unique Lead Number or Project No"
                                                    size="small"
                                                    fullWidth
                                                    style={{ marginBottom: 20 }}
                                                    name="referredByCxUniqueLeadNumber"
                                                    value={leadFormData.referredByCxUniqueLeadNumber || ""}
                                                    onChange={(e) => setLeadFormData({
                                                        ...leadFormData,
                                                        referredByCxUniqueLeadNumber: e.target.value,
                                                        referredByEmpName: "",
                                                        referredByEmpMobile: ""
                                                    })}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    label="Enter Reference Client WhatsApp Number"
                                                    size="small"
                                                    fullWidth
                                                    style={{ marginBottom: 20 }}
                                                    name="referredByCxMobile"
                                                    value={leadFormData.referredByCxMobile || ""}
                                                    onChange={(e) => {
                                                        const mobileNumber = e.target.value;
                                                        setLeadFormData({ ...leadFormData, referredByCxMobile: mobileNumber });
                                                    }}
                                                    variant="outlined"
                                                    error={leadFormData.referredByCxMobile.length > 0 &&
                                                        testRegexEmpCxMobile(leadFormData.referredByCxMobile)
                                                    }
                                                    helperText={
                                                        leadFormData.referredByCxMobile.length > 0 &&
                                                            testRegexEmpCxMobile(leadFormData.referredByCxMobile)
                                                            ? "Enter a valid 10-digit mobile number"
                                                            : ""
                                                    }
                                                />

                                            </>
                                        );
                                    }

                                    if (selectedSource === "Reference Employee") {
                                        return (
                                            <>
                                                <TextField
                                                    label="Enter Reference Employee Name"
                                                    size="small"
                                                    fullWidth
                                                    style={{ marginBottom: 20 }}
                                                    name="referredByEmpName"
                                                    value={leadFormData.referredByEmpName || ""}
                                                    onChange={(e) => setLeadFormData({
                                                        ...leadFormData,
                                                        referredByEmpName: e.target.value,
                                                        referredByCxName: "",
                                                        referredByCxUniqueLeadNumber: "",
                                                        referredByCxMobile: ""
                                                    })}
                                                    variant="outlined"
                                                    error={leadFormData.referredByEmpName.length > 0 &&
                                                        testRegexEmpCxName(leadFormData.referredByEmpName)}
                                                    helperText={
                                                        leadFormData.referredByEmpName.length > 0 &&
                                                            testRegexEmpCxName(leadFormData.referredByEmpName)
                                                            ? "Name should not contain any sign or number"
                                                            : ""
                                                    }
                                                />
                                                <TextField
                                                    label="Enter Reference Employee Email"
                                                    size="small"
                                                    fullWidth
                                                    style={{ marginBottom: 20 }}
                                                    name="referredByEmpEmail"
                                                    value={leadFormData.referredByEmpEmail || ""}
                                                    onChange={(e) => setLeadFormData({
                                                        ...leadFormData,
                                                        referredByEmpEmail: e.target.value,
                                                        referredByCxName: "",
                                                        referredByCxUniqueLeadNumber: "",
                                                        referredByCxMobile: ""
                                                    })}
                                                    variant="outlined"
                                                    error={leadFormData.referredByEmpEmail.length > 0 &&
                                                        testRegexEmpCxEmail(leadFormData.referredByEmpEmail)}
                                                    helperText={
                                                        leadFormData.referredByEmpEmail.length > 0 &&
                                                            testRegexEmpCxEmail(leadFormData.referredByEmpEmail)
                                                            ? "Please enter a valid email address"
                                                            : ""
                                                    }
                                                />
                                                <TextField
                                                    label="Enter Reference Employee WhatsApp Number"
                                                    size="small"
                                                    fullWidth
                                                    style={{ marginBottom: 20 }}
                                                    name="referredByEmpMobile"
                                                    value={leadFormData.referredByEmpMobile || ""}
                                                    onChange={(e) => {
                                                        const mobileNumber = e.target.value;
                                                        setLeadFormData({ ...leadFormData, referredByEmpMobile: mobileNumber });
                                                    }}
                                                    variant="outlined"
                                                    error={leadFormData.referredByEmpMobile.length > 0 &&
                                                        testRegexEmpCxMobile(leadFormData.referredByEmpMobile)}
                                                    helperText={
                                                        leadFormData.referredByEmpMobile.length > 0 &&
                                                            testRegexEmpCxMobile(leadFormData.referredByEmpMobile)
                                                            ? "Enter a valid 10-digit mobile number"
                                                            : ""
                                                    }
                                                />
                                            </>
                                        );
                                    }

                                    return null;
                                })()}

                                <Typography className={classes.sectionTitle}>
                                    <AttachFileIcon fontSize="small" /> Attachments
                                </Typography>
                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={floorPlan}
                                        name="floorPlan"
                                        label="Floor Plan"
                                        onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        <MenuItem value='Yes'>Yes</MenuItem>
                                        <MenuItem value='No'>No</MenuItem>
                                    </TextField>
                                </FormControl>

                                {/* Add new field Expected Handover Date when create a new lead */}
                                <TextField
                                    id="filled-start-adornment"
                                    name="expectedHandoverDate"
                                    sx={{ m: 1, width: '25ch' }}
                                    type='date'
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">Expected Handover Date</InputAdornment>,
                                    }}
                                    onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })}
                                    variant="outlined"
                                    inputProps={{
                                        min: today, // Set the minimum date to today
                                    }}
                                />

                                <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 20, display: 'block' }}>
                                    <>
                                        <input
                                            accept="*"
                                            className={classes.input}
                                            id="contained-button-file"
                                            multiple
                                            type="file"
                                            onChange={onImageChange}
                                            style={{ display: 'none' }}
                                            name="floorPlanAttachment"
                                        />
                                        <label htmlFor="contained-button-file">
                                            <Button className={classes.pillButton} variant="contained" color="primary"
                                                component="span" startIcon={<CloudUploadIcon />}>
                                                Upload Floor Plan
                                            </Button>
                                            {
                                                fileUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />
                                            }
                                        </label>
                                    </>
                                </FormControl>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 20, marginTop: 5, marginBottom: 30 }}>
                                    {/* Checkboxes - Now in a single row */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isAudioEnabled}
                                                    onChange={() => setIsAudioEnabled(!isAudioEnabled)}
                                                    color="primary"
                                                />
                                            }
                                            label="Enable Upload Audio*"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isImageEnabled}
                                                    onChange={() => setIsImageEnabled(!isImageEnabled)}
                                                    color="primary"
                                                />
                                            }
                                            label="Enable Upload Image*"
                                        />
                                    </div>

                                    {/* Upload Buttons - Now in a separate row */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                        {/* Audio File Upload */}
                                        <FormControl>
                                            <input
                                                accept="*"
                                                id="contained-button-file1"
                                                multiple
                                                type="file"
                                                onChange={onImageChange}
                                                style={{ display: 'none' }}
                                                disabled={!isAudioEnabled}
                                                name="recordingFile"
                                            />
                                            <label htmlFor="contained-button-file1">
                                                <Button
                                                    className={classes.pillButton}
                                                    variant="contained"
                                                    color="primary"
                                                    component="span"
                                                    startIcon={<CloudUploadIcon />}
                                                    disabled={!isAudioEnabled}
                                                >
                                                    Upload Audio Files
                                                </Button>
                                                {audioUploaded && (
                                                    <CheckCircleIcon
                                                        style={{ verticalAlign: 'middle', marginLeft: 10, color: 'green', fontSize: 30 }}
                                                    />
                                                )}
                                            </label>
                                        </FormControl>

                                        {/* Image Upload */}
                                        <FormControl>
                                            <input
                                                accept="*"
                                                id="contained-button-file2"
                                                multiple
                                                type="file"
                                                onChange={onImageChange}
                                                style={{ display: 'none' }}
                                                disabled={!isImageEnabled}
                                                name="uploadedImage"
                                            />
                                            <label htmlFor="contained-button-file2">
                                                <Button
                                                    className={classes.pillButton}
                                                    variant="contained"
                                                    color="primary"
                                                    component="span"
                                                    startIcon={<CloudUploadIcon />}
                                                    disabled={!isImageEnabled}
                                                >
                                                    Upload Images
                                                </Button>
                                                {imageUploaded && (
                                                    <CheckCircleIcon
                                                        style={{ verticalAlign: 'middle', marginLeft: 10, color: 'green', fontSize: 30 }}
                                                    />
                                                )}
                                            </label>
                                        </FormControl>
                                    </div>
                                </div>

                                <Typography className={classes.sectionTitle}>
                                    <GroupIcon fontSize="small" /> Assignment
                                </Typography>
                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="leadType"
                                        value={leadType}
                                        label="Status (Do not ask)"
                                        onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {(!isJunk && !isHold) && <MenuItem value='Real'>Real</MenuItem>}
                                        <MenuItem value='Junk'>Junk</MenuItem>
                                        <MenuItem value='Hold'>Hold</MenuItem>
                                        {(!isJunk && !isHold) && <MenuItem value='To Be Called'>To Be Called</MenuItem>}
                                    </TextField>
                                </FormControl>



                                {
                                    leadType !== 'To Be Called' && leadType !== 'Real' && leadMoved ?
                                        <TextField
                                            fullWidth
                                            label="Reason To Assign Other Lead*"
                                            size="small"
                                            style={{ marginBottom: 20, textAlign: "center" }}
                                            name="reasonForOtherLeadType"
                                            value={reasonForOtherLeadType}
                                            onChange={(e) => setLeadFormData({ ...leadFormData, [e.target.name]: e.target.value })}
                                            variant="outlined" />
                                        : ''
                                }

                                {
                                    (leadType !== 'To Be Called' && leadType === 'Real' || leadMoved) &&
                                    (
                                        <FormControl fullWidth style={{ marginBottom: 20 }}>
                                            <TextField
                                                select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="assignToManager"
                                                value={assignToManager}
                                                label="Assign To Team"
                                                onChange={checkAssignDetail}
                                                variant="outlined"
                                                size="small"
                                            >
                                                {managerOfSalesTeam?.map((data) => (
                                                    <MenuItem key={data._id} value={data._id}>
                                                        {`${data?.teamId?.name} - ${data?.name}`}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                    )
                                }

                                {
                                    (leadType === 'To Be Called' || leadType === 'Real' || leadMoved) ?
                                        <Button onClick={addLead} className={classes.submitButton} variant="contained" color="primary" style={{ marginBottom: 20, width: "30%" }}
                                            disabled={btnDisable || customerName === '' || address === '' || area === '' || city === '' || experienceCenterId === '' || email === '' || invalidEmail || !isFileUploaded() || sourceOfLead === '' ||
                                                ((selectedSource === "Reference Client") &&
                                                    (leadFormData.referredByCxName === '' ||
                                                        testRegexEmpCxName(leadFormData.referredByCxName) ||
                                                        leadFormData.referredByCxEmail === '' ||
                                                        testRegexEmpCxEmail(leadFormData.referredByCxEmail) ||
                                                        leadFormData.referredByCxMobile.length !== 10 ||
                                                        testRegexEmpCxMobile(leadFormData.referredByCxMobile)
                                                        || leadFormData.referredByCxUniqueLeadNumber === '')) ||
                                                ((selectedSource === "Reference Employee") &&
                                                    (leadFormData.referredByEmpName === '' ||
                                                        testRegexEmpCxName(leadFormData.referredByEmpName) ||
                                                        leadFormData.referredByEmpEmail === '' ||
                                                        testRegexEmpCxEmail(leadFormData.referredByEmpEmail) ||
                                                        leadFormData.referredByEmpMobile.length !== 10 ||
                                                        testRegexEmpCxMobile(leadFormData.referredByEmpMobile)
                                                    ))
                                            }
                                        >
                                            Submit
                                        </Button>
                                        :
                                        (leadType !== 'Real' && !leadMoved) && (
                                            <div>
                                                <Button
                                                    className={classes.submitButton}
                                                    variant="contained"
                                                    color="primary"
                                                    style={{ marginBottom: 20, width: "30%" }}
                                                    onClick={handleClickOpen}
                                                    disabled={btnDisable || customerName === '' || address === '' || area === '' || city === '' || experienceCenterId === '' || email === '' || invalidEmail || !isFileUploaded() || sourceOfLead === '' ||
                                                        ((selectedSource === "Reference Client") &&
                                                            (leadFormData.referredByCxName === '' ||
                                                                testRegexEmpCxName(leadFormData.referredByCxName) ||
                                                                leadFormData.referredByCxEmail === '' ||
                                                                testRegexEmpCxEmail(leadFormData.referredByCxEmail) ||
                                                                leadFormData.referredByCxMobile.length !== 10 ||
                                                                testRegexEmpCxMobile(leadFormData.referredByCxMobile)
                                                                || leadFormData.referredByCxUniqueLeadNumber === '')) ||
                                                        ((selectedSource === "Reference Employee") &&
                                                            (leadFormData.referredByEmpName === '' ||
                                                                testRegexEmpCxName(leadFormData.referredByEmpName) ||
                                                                leadFormData.referredByEmpEmail === '' ||
                                                                testRegexEmpCxEmail(leadFormData.referredByEmpEmail) ||
                                                                leadFormData.referredByEmpMobile.length !== 10 ||
                                                                testRegexEmpCxMobile(leadFormData.referredByEmpMobile)
                                                            ))
                                                    }

                                                >
                                                    Submit
                                                </Button>

                                                <Dialog
                                                    open={openModal}
                                                    onClose={(event, reason) => {
                                                        if (reason !== 'backdropClick') {
                                                            handleClose();
                                                        }
                                                    }}
                                                    PaperProps={{ className: classes.dialogPaper }}
                                                >
                                                    <DialogTitle className={classes.dialogTitle}>{"Do You Want to Move Lead to Sales User?"}</DialogTitle>
                                                    <DialogContent style={{ paddingTop: 20 }}>
                                                        <DialogContentText>
                                                            If you select Yes, the lead will be moved to a Sales User.
                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions className={classes.dialogActions}>
                                                        <Button onClick={handleClose} color="primary" className={classes.pillButtonPlain}>
                                                            No
                                                        </Button>
                                                        <Button onClick={handleYes} color="primary" variant="contained" className={classes.pillButton} autoFocus>
                                                            Yes
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </div>)

                                }
                            </div>
                        </div>
                    </div>
                </Paper>

            </div>
            {/*  ui for automation leads bulk upload .. */}
            <Dialog
                open={OpenAddCustomerDialogForAutomationLeads}
                onClose={closeAddCustomerDialogForAutomation}
                aria-labelledby="automation-dialog-title"
                fullWidth
                maxWidth="lg"
                classes={{ container: classes.dialogContainerShift }}
                PaperProps={{ className: classes.dialogPaper }}
            >
                <DialogTitle id="automation-dialog-title" className={classes.dialogTitle}>
                    Add Automation Leads / Customer to ERP
                </DialogTitle>
                <DialogContent style={{ paddingTop: 24, paddingBottom: 8 }}>

                    <div className={classes.uploadZone}>
                        <div className={classes.uploadZoneIconWrap}>
                            <CloudUploadIcon fontSize="large" />
                        </div>
                        <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#1C375D' }}>
                            Upload your automation leads Excel file
                        </Typography>
                        <Typography variant="body2" style={{ color: '#7c8695' }}>
                            Accepts .xlsx / .xls / .csv - we'll verify each row and create the leads automatically
                        </Typography>

                        <div className={classes.uploadZoneActions}>
                            <input
                                accept=".xlsx, .xls, .csv"
                                id="upload-file-input"
                                type="file"
                                ref={automationFileInputRef}
                                onChange={handleFileChangeAutomationLeads}
                                disabled={isCustomersLoadedForAutomation || loading}
                                style={{ display: "none" }}
                            />
                            <label htmlFor="upload-file-input">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={loading ? <CircularProgress size={16} thickness={5} style={{ color: "#fff" }} /> : <CloudUploadIcon />}
                                    disabled={isCustomersLoadedForAutomation || loading}
                                    className={classes.pillButton}
                                >
                                    {loading ? "Verifying..." : "Upload Automation Leads File"}
                                </Button>
                            </label>
                            {addCustomersFileUploadedForAutomation && (
                                <CheckCircleIcon className={classes.popInIcon} style={{ color: "green", fontSize: 30 }} />
                            )}

                            {/* Hidden CSV Link */}
                            <CSVLink
                                headers={headersForAutomationLeads}
                                data={failedAutomationLeadsForCSV}
                                filename="Automation_Leads_Failed_Status.csv"
                                ref={failDownloadRef}
                                style={{ display: "none" }}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!isCustomersLoadedForAutomation || failedStatusDownloading}
                                startIcon={failedStatusDownloading ? <CircularProgress size={16} thickness={5} style={{ color: "#fff" }} /> : <CloudDownloadIcon />}
                                onClick={downloadFailed}
                                className={classes.pillButton}
                            >
                                {failedStatusDownloading ? "Downloading..." : "Download Failed Status"}
                            </Button>
                        </div>
                    </div>

                    {/* Inline verifying progress - same pattern as the bulk leads dialog */}
                    {loading && (
                        <div className={classes.verifyingCard}>
                            <div className={classes.verifyingIconWrap}>
                                <CircularProgress size={22} thickness={5} style={{ color: "#2a5ea8" }} />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Typography variant="body2" style={{ color: '#1C375D', fontWeight: 700 }}>
                                    Verifying &amp; creating automation leads...
                                </Typography>
                                <Typography variant="caption" style={{ color: '#5a6c85' }}>
                                    {automationUploadProgress?.totalRows
                                        ? `${automationUploadProgress.processedRows} of ${automationUploadProgress.totalRows} rows processed - please don't close this window`
                                        : "Reading your file - please don't close this window"}
                                </Typography>
                                <LinearProgress
                                    className={classes.verifyingProgressBar}
                                    variant={automationUploadProgress?.totalRows ? "determinate" : "indeterminate"}
                                    value={
                                        automationUploadProgress?.totalRows
                                            ? Math.min(100, Math.round((automationUploadProgress.processedRows / automationUploadProgress.totalRows) * 100))
                                            : 0
                                    }
                                />
                            </div>
                        </div>
                    )}

                    {addCustomersFileUploadedForAutomation &&
                        <>
                            <div className={classes.resultsHeaderRow}>
                                <Typography variant="h6" className={classes.resultsHeaderTitle}>
                                    <AssignmentIcon /> Upload Results
                                </Typography>
                                <Chip
                                    size="small"
                                    className={classes.resultsSummaryChip}
                                    icon={<CheckCircleIcon style={{ color: "#1e7e34" }} />}
                                    label={`${successfulAutomationLeads.length} Created`}
                                    style={{ background: "#e6f4ea", color: "#1e7e34" }}
                                />
                                <Chip
                                    size="small"
                                    className={classes.resultsSummaryChip}
                                    icon={<ErrorIcon style={{ color: "#c62828" }} />}
                                    label={`${failedAutomationLeads.length} Failed`}
                                    style={{ background: "#fdecea", color: "#c62828" }}
                                />
                            </div>

                            <TableContainer component={Paper} className={classes.resultsTableWrap}>
                                <Table className={classes.table} stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <StyledTableRow>
                                            <TableCell className={classes.resultsHeadCell} align="center">SL No</TableCell>
                                            <TableCell className={classes.resultsHeadCell}>Customer Name</TableCell>
                                            <TableCell className={classes.resultsHeadCell}>Contact No.</TableCell>
                                            <TableCell className={classes.resultsHeadCell}>Email</TableCell>
                                            <TableCell className={classes.resultsHeadCell}>Location</TableCell>
                                            <TableCell className={classes.resultsHeadCell}>Experience Center</TableCell>
                                            <TableCell className={classes.resultsHeadCell}>Platform</TableCell>
                                            <TableCell className={classes.resultsHeadCell}>Error Message</TableCell>
                                            <TableCell className={classes.resultsHeadCell} align="center">Lead Status</TableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {automationResultRows.map((ele, i) => {
                                            const isSuccess = ele.message === "";
                                            return (
                                                <TableRow key={i} className={classes.resultsRow}>
                                                    <TableCell className={classes.resultsSlCell}>{i + 1}</TableCell>
                                                    <TableCell>{ele.name}</TableCell>
                                                    <TableCell>{ele.contactNo}</TableCell>
                                                    <TableCell>{ele.email}</TableCell>
                                                    <TableCell>{ele.location}</TableCell>
                                                    <TableCell>{ele.expCenter}</TableCell>
                                                    <TableCell>{ele.platform}</TableCell>
                                                    <TableCell style={{ color: isSuccess ? "#9aa5b1" : "#c62828" }}>
                                                        {isSuccess ? "—" : ele.message}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Chip
                                                            size="small"
                                                            className={classes.resultsStatusChip}
                                                            icon={isSuccess
                                                                ? <CheckCircleIcon style={{ fontSize: 16, color: "#1e7e34" }} />
                                                                : <ErrorIcon style={{ fontSize: 16, color: "#c62828" }} />}
                                                            label={isSuccess ? "Success" : "Fail"}
                                                            style={{
                                                                background: isSuccess ? "#e6f4ea" : "#fdecea",
                                                                color: isSuccess ? "#1e7e34" : "#c62828",
                                                            }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    }

                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <Button
                        onClick={closeAddCustomerDialogForAutomation}
                        variant="outlined"
                        color="primary"
                        className={classes.pillButtonPlain}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(CreateLead)